export const ActiveSports = [
    {
        name: 'Soccer',
        iconPath: 'football-category-icon-white.png',
        sportId: 1,
        availableLeagues: []
    },
    {
        name: 'Rugby',
        iconPath: 'rugby-category-icon-white.png',
        availableLeagues: []
    },
    {
        name: 'Basketball',
        iconPath: 'basketball-category-icon-white.png',
        availableLeagues: []
    },
    {
        name: 'Cricket',
        iconPath: 'cricket-category-icon-white.png',
        sportId: 3,
        availableLeagues: []
    },
];
